export default __webpack_public_path__ + "static/media/OutOfStock.0c9b3ed7.svg";